import { FC, useState } from 'react'
import cn from 'classnames'
import { Image, ImageProps } from './Image'

import styles from './PoapImage.module.scss'

const PoapImage: FC<ImageProps> = (props) => {
  const { className } = props
  const [isLoaded, setIsLoaded] = useState<Boolean>(false)

  return (
    <Image
      {...props}
      onLoad={() => setIsLoaded(true)}
      className={cn(className, styles.img, isLoaded && styles.loaded)}
    />
  )
}

export default PoapImage
